
export { ProductDetailsSkeleton } from "./ui"